const HEADER_KEYS = new Set([
  "label",
  "title",
  "subtitle",
  "description",
  "popular_badge",
  "buttonoutlinetext",
  "buttonoutlinelink",
  "buttonprimarytext",
  "buttonprimarylink",
  "buttontext",
  "buttonlink",
  "buttonurl",
]);

const PREFIX_LABELS = {
  card: "Card",
  step: "Process step",
  plan: "Hosting plan",
  stat: "Statistic",
  item: "List item",
  tag: "Tag",
  feature: "Feature",
  pin: "Map pin",
  column: "Info column",
  position: "Position",
  article: "Article",
  project: "Project",
  social: "Social",
  company: "Company link",
  resources: "Resources link",
  legal: "Legal link",
};

function normalizeKey(key) {
  return String(key || "").trim().toLowerCase();
}

/**
 * Group CMS section fields into editable panels for cleaner admin UI.
 */
export function groupSectionFields(fields) {
  const sorted = [...fields].sort(
    (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
  );
  const groups = [];
  const assigned = new Set();

  const headerFields = sorted.filter((field) =>
    HEADER_KEYS.has(normalizeKey(field.key))
  );
  headerFields.forEach((field) => assigned.add(field.id));
  if (headerFields.length) {
    groups.push({
      id: "header",
      title: "Section header",
      description: "Main title, labels, buttons, and introductory copy",
      fields: headerFields,
    });
  }

  const repeatRegex = /^([a-z]+)_(\d+)(?:_(.+))?$/i;
  const repeatBuckets = new Map();

  sorted.forEach((field) => {
    if (assigned.has(field.id)) return;

    const key = field.key || "";
    const match = key.match(repeatRegex);
    if (!match) return;

    const [, prefix, index] = match;
    const bucketKey = `${prefix}_${index}`;
    if (!repeatBuckets.has(bucketKey)) {
      repeatBuckets.set(bucketKey, {
        prefix: prefix.toLowerCase(),
        index: Number(index),
        fields: [],
      });
    }
    repeatBuckets.get(bucketKey).fields.push(field);
    assigned.add(field.id);
  });

  [...repeatBuckets.values()]
    .sort((a, b) => a.index - b.index || a.prefix.localeCompare(b.prefix))
    .forEach((bucket) => {
      const label =
        PREFIX_LABELS[bucket.prefix] ||
        bucket.prefix.charAt(0).toUpperCase() + bucket.prefix.slice(1);
      groups.push({
        id: `${bucket.prefix}_${bucket.index}`,
        title: `${label} ${bucket.index + 1}`,
        description: `Fields for ${label.toLowerCase()} ${bucket.index + 1}`,
        fields: bucket.fields.sort(
          (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
        ),
      });
    });

  const remaining = sorted.filter((field) => !assigned.has(field.id));
  if (remaining.length) {
    groups.push({
      id: "other",
      title: remaining.length === 1 ? "Field" : "Additional fields",
      description: "Remaining content fields for this section",
      fields: remaining,
    });
  }

  return groups;
}
